
URL = globalThis.URL
import __vite__wasmUrl from "/opt/buildhome/repo/node_modules/@automerge/automerge/dist/mjs/wasm_bindgen_output/bundler/automerge_wasm_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./automerge_wasm_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./automerge_wasm_bg.js": { "__wbindgen_object_drop_ref": __vite__wasmImport_0["__wbindgen_object_drop_ref"],
"__wbindgen_string_get": __vite__wasmImport_0["__wbindgen_string_get"],
"__wbindgen_error_new": __vite__wasmImport_0["__wbindgen_error_new"],
"__wbindgen_string_new": __vite__wasmImport_0["__wbindgen_string_new"],
"__wbindgen_number_new": __vite__wasmImport_0["__wbindgen_number_new"],
"__wbindgen_object_clone_ref": __vite__wasmImport_0["__wbindgen_object_clone_ref"],
"__wbindgen_number_get": __vite__wasmImport_0["__wbindgen_number_get"],
"__wbindgen_is_undefined": __vite__wasmImport_0["__wbindgen_is_undefined"],
"__wbindgen_boolean_get": __vite__wasmImport_0["__wbindgen_boolean_get"],
"__wbindgen_is_null": __vite__wasmImport_0["__wbindgen_is_null"],
"__wbindgen_is_string": __vite__wasmImport_0["__wbindgen_is_string"],
"__wbindgen_is_function": __vite__wasmImport_0["__wbindgen_is_function"],
"__wbindgen_is_object": __vite__wasmImport_0["__wbindgen_is_object"],
"__wbindgen_is_array": __vite__wasmImport_0["__wbindgen_is_array"],
"__wbindgen_json_serialize": __vite__wasmImport_0["__wbindgen_json_serialize"],
"__wbg_new_abda76e883ba8a5f": __vite__wasmImport_0["__wbg_new_abda76e883ba8a5f"],
"__wbg_stack_658279fe44541cf6": __vite__wasmImport_0["__wbg_stack_658279fe44541cf6"],
"__wbg_error_f851667af71bcfc6": __vite__wasmImport_0["__wbg_error_f851667af71bcfc6"],
"__wbindgen_jsval_loose_eq": __vite__wasmImport_0["__wbindgen_jsval_loose_eq"],
"__wbg_String_91fba7ded13ba54c": __vite__wasmImport_0["__wbg_String_91fba7ded13ba54c"],
"__wbindgen_bigint_from_i64": __vite__wasmImport_0["__wbindgen_bigint_from_i64"],
"__wbindgen_bigint_from_u64": __vite__wasmImport_0["__wbindgen_bigint_from_u64"],
"__wbg_set_20cbc34131e76824": __vite__wasmImport_0["__wbg_set_20cbc34131e76824"],
"__wbg_getRandomValues_3aa56aa6edec874c": __vite__wasmImport_0["__wbg_getRandomValues_3aa56aa6edec874c"],
"__wbg_randomFillSync_5c9c955aa56b6049": __vite__wasmImport_0["__wbg_randomFillSync_5c9c955aa56b6049"],
"__wbg_crypto_1d1f22824a6a080c": __vite__wasmImport_0["__wbg_crypto_1d1f22824a6a080c"],
"__wbg_process_4a72847cc503995b": __vite__wasmImport_0["__wbg_process_4a72847cc503995b"],
"__wbg_versions_f686565e586dd935": __vite__wasmImport_0["__wbg_versions_f686565e586dd935"],
"__wbg_node_104a2ff8d6ea03a2": __vite__wasmImport_0["__wbg_node_104a2ff8d6ea03a2"],
"__wbg_require_cca90b1a94a0255b": __vite__wasmImport_0["__wbg_require_cca90b1a94a0255b"],
"__wbg_msCrypto_eb05e62b530a1508": __vite__wasmImport_0["__wbg_msCrypto_eb05e62b530a1508"],
"__wbg_log_5bb5f88f245d7762": __vite__wasmImport_0["__wbg_log_5bb5f88f245d7762"],
"__wbg_log_1746d5c75ec89963": __vite__wasmImport_0["__wbg_log_1746d5c75ec89963"],
"__wbg_get_bd8e338fbd5f5cc8": __vite__wasmImport_0["__wbg_get_bd8e338fbd5f5cc8"],
"__wbg_length_cd7af8117672b8b8": __vite__wasmImport_0["__wbg_length_cd7af8117672b8b8"],
"__wbg_new_16b304a2cfa7ff4a": __vite__wasmImport_0["__wbg_new_16b304a2cfa7ff4a"],
"__wbg_newnoargs_e258087cd0daa0ea": __vite__wasmImport_0["__wbg_newnoargs_e258087cd0daa0ea"],
"__wbg_next_40fc327bfc8770e6": __vite__wasmImport_0["__wbg_next_40fc327bfc8770e6"],
"__wbg_next_196c84450b364254": __vite__wasmImport_0["__wbg_next_196c84450b364254"],
"__wbg_done_298b57d23c0fc80c": __vite__wasmImport_0["__wbg_done_298b57d23c0fc80c"],
"__wbg_value_d93c65011f51a456": __vite__wasmImport_0["__wbg_value_d93c65011f51a456"],
"__wbg_iterator_2cee6dadfd956dfa": __vite__wasmImport_0["__wbg_iterator_2cee6dadfd956dfa"],
"__wbg_get_e3c254076557e348": __vite__wasmImport_0["__wbg_get_e3c254076557e348"],
"__wbg_call_27c0f87801dedf93": __vite__wasmImport_0["__wbg_call_27c0f87801dedf93"],
"__wbg_new_72fb9a18b5ae2624": __vite__wasmImport_0["__wbg_new_72fb9a18b5ae2624"],
"__wbg_length_dee433d4c85c9387": __vite__wasmImport_0["__wbg_length_dee433d4c85c9387"],
"__wbg_set_d4638f722068f043": __vite__wasmImport_0["__wbg_set_d4638f722068f043"],
"__wbg_from_89e3fc3ba5e6fb48": __vite__wasmImport_0["__wbg_from_89e3fc3ba5e6fb48"],
"__wbg_isArray_2ab64d95e09ea0ae": __vite__wasmImport_0["__wbg_isArray_2ab64d95e09ea0ae"],
"__wbg_push_a5b05aedc7234f9f": __vite__wasmImport_0["__wbg_push_a5b05aedc7234f9f"],
"__wbg_unshift_e22df4b34bcf5070": __vite__wasmImport_0["__wbg_unshift_e22df4b34bcf5070"],
"__wbg_instanceof_ArrayBuffer_836825be07d4c9d2": __vite__wasmImport_0["__wbg_instanceof_ArrayBuffer_836825be07d4c9d2"],
"__wbg_new_28c511d9baebfa89": __vite__wasmImport_0["__wbg_new_28c511d9baebfa89"],
"__wbg_call_b3ca7c6051f9bec1": __vite__wasmImport_0["__wbg_call_b3ca7c6051f9bec1"],
"__wbg_instanceof_Date_f65cf97fb83fc369": __vite__wasmImport_0["__wbg_instanceof_Date_f65cf97fb83fc369"],
"__wbg_getTime_2bc4375165f02d15": __vite__wasmImport_0["__wbg_getTime_2bc4375165f02d15"],
"__wbg_new_cf3ec55744a78578": __vite__wasmImport_0["__wbg_new_cf3ec55744a78578"],
"__wbg_instanceof_Object_71ca3c0a59266746": __vite__wasmImport_0["__wbg_instanceof_Object_71ca3c0a59266746"],
"__wbg_assign_496d2d14fecafbcf": __vite__wasmImport_0["__wbg_assign_496d2d14fecafbcf"],
"__wbg_defineProperty_cc00e2de8a0f5141": __vite__wasmImport_0["__wbg_defineProperty_cc00e2de8a0f5141"],
"__wbg_entries_95cc2c823b285a09": __vite__wasmImport_0["__wbg_entries_95cc2c823b285a09"],
"__wbg_freeze_cc6bc19f75299986": __vite__wasmImport_0["__wbg_freeze_cc6bc19f75299986"],
"__wbg_keys_91e412b4b222659f": __vite__wasmImport_0["__wbg_keys_91e412b4b222659f"],
"__wbg_values_9c75e6e2bfbdb70d": __vite__wasmImport_0["__wbg_values_9c75e6e2bfbdb70d"],
"__wbg_new_dd6a5dd7b538af21": __vite__wasmImport_0["__wbg_new_dd6a5dd7b538af21"],
"__wbg_apply_0a5aa603881e6d79": __vite__wasmImport_0["__wbg_apply_0a5aa603881e6d79"],
"__wbg_deleteProperty_13e721a56f19e842": __vite__wasmImport_0["__wbg_deleteProperty_13e721a56f19e842"],
"__wbg_ownKeys_658942b7f28d1fe9": __vite__wasmImport_0["__wbg_ownKeys_658942b7f28d1fe9"],
"__wbg_set_1f9b04f170055d33": __vite__wasmImport_0["__wbg_set_1f9b04f170055d33"],
"__wbg_buffer_12d079cc21e14bdb": __vite__wasmImport_0["__wbg_buffer_12d079cc21e14bdb"],
"__wbg_concat_3de229fe4fe90fea": __vite__wasmImport_0["__wbg_concat_3de229fe4fe90fea"],
"__wbg_slice_52fb626ffdc8da8f": __vite__wasmImport_0["__wbg_slice_52fb626ffdc8da8f"],
"__wbg_for_27c67e2dbdce22f6": __vite__wasmImport_0["__wbg_for_27c67e2dbdce22f6"],
"__wbg_toString_7df3c77999517c20": __vite__wasmImport_0["__wbg_toString_7df3c77999517c20"],
"__wbg_self_ce0dbfc45cf2f5be": __vite__wasmImport_0["__wbg_self_ce0dbfc45cf2f5be"],
"__wbg_window_c6fb939a7f436783": __vite__wasmImport_0["__wbg_window_c6fb939a7f436783"],
"__wbg_globalThis_d1e6af4856ba331b": __vite__wasmImport_0["__wbg_globalThis_d1e6af4856ba331b"],
"__wbg_global_207b558942527489": __vite__wasmImport_0["__wbg_global_207b558942527489"],
"__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb": __vite__wasmImport_0["__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb"],
"__wbg_new_63b92bc8671ed464": __vite__wasmImport_0["__wbg_new_63b92bc8671ed464"],
"__wbg_set_a47bac70306a19a7": __vite__wasmImport_0["__wbg_set_a47bac70306a19a7"],
"__wbg_length_c20a40f15020d68a": __vite__wasmImport_0["__wbg_length_c20a40f15020d68a"],
"__wbg_instanceof_Uint8Array_2b3bbecd033d19f6": __vite__wasmImport_0["__wbg_instanceof_Uint8Array_2b3bbecd033d19f6"],
"__wbg_newwithlength_e9b4878cebadb3d3": __vite__wasmImport_0["__wbg_newwithlength_e9b4878cebadb3d3"],
"__wbg_subarray_a1f73cd4b5b42fe1": __vite__wasmImport_0["__wbg_subarray_a1f73cd4b5b42fe1"],
"__wbindgen_debug_string": __vite__wasmImport_0["__wbindgen_debug_string"],
"__wbindgen_throw": __vite__wasmImport_0["__wbindgen_throw"],
"__wbindgen_memory": __vite__wasmImport_0["__wbindgen_memory"] } }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const __wbg_syncstate_free = __vite__wasmModule.__wbg_syncstate_free;
export const syncstate_sharedHeads = __vite__wasmModule.syncstate_sharedHeads;
export const syncstate_lastSentHeads = __vite__wasmModule.syncstate_lastSentHeads;
export const syncstate_set_lastSentHeads = __vite__wasmModule.syncstate_set_lastSentHeads;
export const syncstate_set_sentHashes = __vite__wasmModule.syncstate_set_sentHashes;
export const syncstate_clone = __vite__wasmModule.syncstate_clone;
export const __wbg_automerge_free = __vite__wasmModule.__wbg_automerge_free;
export const automerge_new = __vite__wasmModule.automerge_new;
export const automerge_clone = __vite__wasmModule.automerge_clone;
export const automerge_fork = __vite__wasmModule.automerge_fork;
export const automerge_pendingOps = __vite__wasmModule.automerge_pendingOps;
export const automerge_commit = __vite__wasmModule.automerge_commit;
export const automerge_merge = __vite__wasmModule.automerge_merge;
export const automerge_rollback = __vite__wasmModule.automerge_rollback;
export const automerge_keys = __vite__wasmModule.automerge_keys;
export const automerge_text = __vite__wasmModule.automerge_text;
export const automerge_spans = __vite__wasmModule.automerge_spans;
export const automerge_splice = __vite__wasmModule.automerge_splice;
export const automerge_updateText = __vite__wasmModule.automerge_updateText;
export const automerge_updateSpans = __vite__wasmModule.automerge_updateSpans;
export const automerge_push = __vite__wasmModule.automerge_push;
export const automerge_pushObject = __vite__wasmModule.automerge_pushObject;
export const automerge_insert = __vite__wasmModule.automerge_insert;
export const automerge_splitBlock = __vite__wasmModule.automerge_splitBlock;
export const automerge_joinBlock = __vite__wasmModule.automerge_joinBlock;
export const automerge_updateBlock = __vite__wasmModule.automerge_updateBlock;
export const automerge_getBlock = __vite__wasmModule.automerge_getBlock;
export const automerge_insertObject = __vite__wasmModule.automerge_insertObject;
export const automerge_put = __vite__wasmModule.automerge_put;
export const automerge_putObject = __vite__wasmModule.automerge_putObject;
export const automerge_increment = __vite__wasmModule.automerge_increment;
export const automerge_get = __vite__wasmModule.automerge_get;
export const automerge_getWithType = __vite__wasmModule.automerge_getWithType;
export const automerge_objInfo = __vite__wasmModule.automerge_objInfo;
export const automerge_getAll = __vite__wasmModule.automerge_getAll;
export const automerge_enableFreeze = __vite__wasmModule.automerge_enableFreeze;
export const automerge_registerDatatype = __vite__wasmModule.automerge_registerDatatype;
export const automerge_applyPatches = __vite__wasmModule.automerge_applyPatches;
export const automerge_applyAndReturnPatches = __vite__wasmModule.automerge_applyAndReturnPatches;
export const automerge_diffIncremental = __vite__wasmModule.automerge_diffIncremental;
export const automerge_updateDiffCursor = __vite__wasmModule.automerge_updateDiffCursor;
export const automerge_resetDiffCursor = __vite__wasmModule.automerge_resetDiffCursor;
export const automerge_diff = __vite__wasmModule.automerge_diff;
export const automerge_isolate = __vite__wasmModule.automerge_isolate;
export const automerge_integrate = __vite__wasmModule.automerge_integrate;
export const automerge_length = __vite__wasmModule.automerge_length;
export const automerge_delete = __vite__wasmModule.automerge_delete;
export const automerge_save = __vite__wasmModule.automerge_save;
export const automerge_saveIncremental = __vite__wasmModule.automerge_saveIncremental;
export const automerge_saveSince = __vite__wasmModule.automerge_saveSince;
export const automerge_saveNoCompress = __vite__wasmModule.automerge_saveNoCompress;
export const automerge_saveAndVerify = __vite__wasmModule.automerge_saveAndVerify;
export const automerge_loadIncremental = __vite__wasmModule.automerge_loadIncremental;
export const automerge_applyChanges = __vite__wasmModule.automerge_applyChanges;
export const automerge_getChanges = __vite__wasmModule.automerge_getChanges;
export const automerge_getChangeByHash = __vite__wasmModule.automerge_getChangeByHash;
export const automerge_getDecodedChangeByHash = __vite__wasmModule.automerge_getDecodedChangeByHash;
export const automerge_getChangesAdded = __vite__wasmModule.automerge_getChangesAdded;
export const automerge_getHeads = __vite__wasmModule.automerge_getHeads;
export const automerge_getActorId = __vite__wasmModule.automerge_getActorId;
export const automerge_getLastLocalChange = __vite__wasmModule.automerge_getLastLocalChange;
export const automerge_dump = __vite__wasmModule.automerge_dump;
export const automerge_getMissingDeps = __vite__wasmModule.automerge_getMissingDeps;
export const automerge_receiveSyncMessage = __vite__wasmModule.automerge_receiveSyncMessage;
export const automerge_generateSyncMessage = __vite__wasmModule.automerge_generateSyncMessage;
export const automerge_toJS = __vite__wasmModule.automerge_toJS;
export const automerge_materialize = __vite__wasmModule.automerge_materialize;
export const automerge_getCursor = __vite__wasmModule.automerge_getCursor;
export const automerge_getCursorPosition = __vite__wasmModule.automerge_getCursorPosition;
export const automerge_emptyChange = __vite__wasmModule.automerge_emptyChange;
export const automerge_mark = __vite__wasmModule.automerge_mark;
export const automerge_unmark = __vite__wasmModule.automerge_unmark;
export const automerge_marks = __vite__wasmModule.automerge_marks;
export const automerge_marksAt = __vite__wasmModule.automerge_marksAt;
export const automerge_hasOurChanges = __vite__wasmModule.automerge_hasOurChanges;
export const automerge_topoHistoryTraversal = __vite__wasmModule.automerge_topoHistoryTraversal;
export const automerge_stats = __vite__wasmModule.automerge_stats;
export const create = __vite__wasmModule.create;
export const load = __vite__wasmModule.load;
export const encodeChange = __vite__wasmModule.encodeChange;
export const decodeChange = __vite__wasmModule.decodeChange;
export const initSyncState = __vite__wasmModule.initSyncState;
export const importSyncState = __vite__wasmModule.importSyncState;
export const exportSyncState = __vite__wasmModule.exportSyncState;
export const encodeSyncMessage = __vite__wasmModule.encodeSyncMessage;
export const decodeSyncMessage = __vite__wasmModule.decodeSyncMessage;
export const encodeSyncState = __vite__wasmModule.encodeSyncState;
export const decodeSyncState = __vite__wasmModule.decodeSyncState;
export const __wbindgen_malloc = __vite__wasmModule.__wbindgen_malloc;
export const __wbindgen_realloc = __vite__wasmModule.__wbindgen_realloc;
export const __wbindgen_add_to_stack_pointer = __vite__wasmModule.__wbindgen_add_to_stack_pointer;
export const __wbindgen_free = __vite__wasmModule.__wbindgen_free;
export const __wbindgen_exn_store = __vite__wasmModule.__wbindgen_exn_store;
